var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "24px",
        height: "25px",
        viewBox: "0 0 24 25",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
      },
    },
    [
      _c("title", [_vm._v("Engine calculation error")]),
      _vm._v(" "),
      _c(
        "g",
        {
          attrs: {
            id: "engine-calculation-error-container",
            stroke: "none",
            "stroke-width": "1",
            fill: "none",
            "fill-rule": "evenodd",
          },
        },
        [
          _c(
            "g",
            {
              attrs: {
                id: "engine-calculation-error-transform",
                transform: "translate(-138.000000, -599.000000)",
                "fill-rule": "nonzero",
              },
            },
            [
              _c(
                "g",
                {
                  attrs: {
                    id: "engine-calculation-error",
                    transform: "translate(138.000000, 599.000000)",
                  },
                },
                [
                  _c("rect", {
                    attrs: {
                      id: "Rectangle",
                      x: "0",
                      y: "0",
                      width: "24",
                      height: "24",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      id: "Combined-Shape",
                      d: "M6.20712,18.8071 C6.48326,18.531 6.93098,18.531 7.20712,18.8071 C7.48327,19.0833 7.48327,19.531 7.20712,19.8071 L7.20712,19.8071 L5.70714,21.3071 L7.20712,22.8071 C7.48326,23.0832 7.48327,23.531 7.20712,23.8071 C6.93098,24.0832 6.48327,24.0832 6.20712,23.8071 L6.20712,23.8071 L4.70714,22.3071 L3.20712,23.8071 C2.93098,24.0833 2.48327,24.0833 2.20712,23.8071 C1.93098,23.531 1.93098,23.0833 2.20712,22.8071 L2.20712,22.8071 L3.70714,21.3071 L2.20712,19.8071 C1.93098,19.531 1.93098,19.0832 2.20712,18.8071 C2.48326,18.531 2.93098,18.531 3.20712,18.8071 L3.20712,18.8071 L4.70714,20.3071 Z M20.8071,18.8071 C21.0833,18.531 21.531,18.531 21.8071,18.8071 C22.0833,19.0833 22.0833,19.531 21.8071,19.8071 L21.8071,19.8071 L20.3071,21.3071 L21.8071,22.8071 C22.0833,23.0832 22.0833,23.531 21.8071,23.8071 C21.531,24.0832 21.0833,24.0832 20.8071,23.8071 L20.8071,23.8071 L19.3071,22.3071 L17.8071,23.8071 C17.531,24.0833 17.0833,24.0833 16.8071,23.8071 C16.531,23.531 16.531,23.0833 16.8071,22.8071 L16.8071,22.8071 L18.3071,21.3071 L16.8071,19.8071 C16.531,19.531 16.531,19.0832 16.8071,18.8071 C17.0833,18.531 17.531,18.531 17.8071,18.8071 L17.8071,18.8071 L19.3071,20.3071 Z M13.5071,18.8071 C13.7833,18.531 14.231,18.531 14.5071,18.8071 C14.7833,19.0833 14.7833,19.531 14.5071,19.8071 L14.5071,19.8071 L13.0071,21.3071 L14.5071,22.8071 C14.7833,23.0832 14.7833,23.531 14.5071,23.8071 C14.231,24.0832 13.7833,24.0832 13.5071,23.8071 L13.5071,23.8071 L12.0071,22.3071 L10.5071,23.8071 C10.231,24.0833 9.78325,24.0833 9.50711,23.8071 C9.23097,23.531 9.23097,23.0833 9.50711,22.8071 L9.50711,22.8071 L11.0071,21.3071 L9.50711,19.8071 C9.23097,19.531 9.23097,19.0832 9.50711,18.8071 C9.78325,18.531 10.231,18.531 10.5071,18.8071 L10.5071,18.8071 L12.0071,20.3071 Z M21,14 C21.5522847,14 22,14.4477153 22,15 C22,15.5522847 21.5522847,16 21,16 L3,16 C2.44771525,16 2,15.5522847 2,15 C2,14.4477153 2.44771525,14 3,14 L21,14 Z M20,7 C21.1046,7 22,7.89543 22,9 L22,9 L22,10 C22,11.1046 21.1046,12 20,12 L20,12 L4,12 C2.89543,12 2,11.1046 2,10 L2,10 L2,9 C2,7.89543 2.89543,7 4,7 L4,7 Z M20,9 L4,9 L4,10 L20,10 L20,9 Z M20,0 C21.1046,0 22,0.895431 22,2 L22,2 L22,3 C22,4.10457 21.1046,5 20,5 L20,5 L4,5 C2.89543,5 2,4.10457 2,3 L2,3 L2,2 C2,0.89543 2.89543,0 4,0 L4,0 Z M20,2 L4,2 L4,3 L20,3 L20,2 Z",
                      fill: "#6D7278",
                    },
                  }),
                ]
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }